export const absentReminderColumns = [
    {
        field: "date",
        headerName: "Date",
        width: 120,
    },
    {
        field: "timeSlot",
        headerName: "TimeSlot",
        width: 160,
    },
    {
        field: "reminderSMS",
        headerName: "Reminder SMS",
        width: 160
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "clientNumber",
        headerName: "User Contact No.",
        width: 160,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        width: 120,
    },
  ];